import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const ShopPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main className="py-16 md:py-24">
        <div className="container mx-auto px-4">
          <div className="text-center max-w-3xl mx-auto">
            <h1 className="text-4xl md:text-5xl font-bold text-swastik-blue font-serif mb-6">Coming Soon</h1>
            <p className="text-lg text-gray-600 mb-8">
              Our online shop is under construction. We're working hard to bring you our selection of Ayurvedic products and wellness items.
            </p>
            <div className="bg-swastik-blue/10 p-8 rounded-lg">
              <h2 className="text-2xl font-semibold text-swastik-blue mb-4">What to Expect</h2>
              <ul className="text-left space-y-3 text-gray-600">
                <li className="flex items-start">
                  <span className="text-swastik-blue mr-2">•</span>
                  Authentic Ayurvedic products and herbal supplements
                </li>
                <li className="flex items-start">
                  <span className="text-swastik-blue mr-2">•</span>
                  Natural wellness and self-care items
                </li>
                <li className="flex items-start">
                  <span className="text-swastik-blue mr-2">•</span>
                  Expert guidance on product selection
                </li>
                <li className="flex items-start">
                  <span className="text-swastik-blue mr-2">•</span>
                  Secure online shopping experience
                </li>
              </ul>
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ShopPage; 